// RightSide.jsx
import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import {  forgotPassword } from "../../api/api";
import { useNavigate, NavLink } from "react-router-dom";

const ForgotPasswordComponent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    const email = values.email;
    try {
      setIsLoading(true);
      const { data, res } = await forgotPassword({
        email,
      });
      if (res.status === 200) {
        setIsLoading(false);
        // setModal(true);
        message.success("Email sent successfully.");
        navigate("/auth/login/");
      } else {
        message.error(data.error);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
      return err.message;
    }
    // setTimeout(() => {
    //   setIsLoading(false);
    // }, 2000);
  };

    function onClick() {
    navigate("/auth/demo-request/");
  }
  return (

    <div className="glass-card shadow-lg text-white rounded-lg p-10 w-full max-w-md">
      <h1 className="text-center  text-2xl font-bold mb-6">
        Forgot Password
      </h1>

      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="email"
          label="Email"
          rules={[{ required: true, message: "Please enter your email." }]}
        >
          <Input className="glass-card" type="email" placeholder="john@gmail.com" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            block
            htmlType="submit"
            loading={isLoading}
            style={{ backgroundColor: "#122253", borderColor: "#122253", borderRadius: "8px", height: "40px" }}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>

        <div className="text-sm text-left flex justify-between">
          <p>
            Already have an account?{" "}
            <NavLink
              to={"/auth/login/"}
              style={{ color: "#122253", fontWeight: "bold" }}
            >
              LOGIN
            </NavLink>
          </p>
        </div>
      </Form>
    </div>
  );
};

export default ForgotPasswordComponent;
